'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 243 242",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M121 0c66.827 0 121 54.174 121 121 0 66.827-54.173 121-121 121C54.174 242 0 187.827 0 121 0 54.174 54.174 0 121 0Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__a)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M-5-5h252v252H-5Z",
    fill: "#1098f3"
  })), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__b"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M122 0c66.827 0 121 54.174 121 121 0 66.827-54.173 121-121 121C55.174 242 1 187.827 1 121 1 54.174 55.174 0 122 0Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__c"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M0-8h242v232H0Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__c)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__d"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M196.405 59.192c3.64-1.354-3.568-17.406-10.454-13.566-6.954 3.876-24.895 10.546-26.313 10.232-5.705-1.264-17.48-2.475-22.196-3.345-8.254-1.523-15.626-1.507-20.51.699-5.175 2.338-2.62 6.625 1.257 7.76 2.89.846 35.746 9.557 44.062 8.292.721-.11 21.386-5.326 34.154-10.072",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__d)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__e"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__e)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M109.022 167.61h93.36v34.356h-93.36Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__f"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M117.625 64.004c2.74 1.252 34.008 14.575 42.421 14.51.666-.006 18.434-1.847 31.655-4.357l-.106-.006.516-11.207 2.43.111c-1.744-3.277-4.463-5.767-7.657-4.546-7.436 2.843-26.145 6.878-27.503 6.363-5.468-2.067-16.947-4.95-21.492-6.486-7.951-2.687-15.25-3.728-20.4-2.243-5.454 1.574-3.54 6.183.136 7.861",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__f)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__g"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__g)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M109.091 158.487h90.45v33.049h-90.45Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__h"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M113.864 70.405c2.855 1.24 35.453 14.423 44.24 14.32.638-.006 16.303-1.627 29.556-3.879l.274-6.013a218.94 218.94 0 0 0 3.767-.676l-.106-.006.265-5.732 2.005.094c-.555-.91-1.19-1.739-1.9-2.416l.146-3.153 2.43.111c-.505-.95-1.095-1.83-1.752-2.575 1.256-.431 2.468-.86 3.616-1.288 3.64-1.354-3.568-17.406-10.454-13.566-6.954 3.876-24.895 10.546-26.313 10.232-5.705-1.264-17.48-2.475-22.196-3.345-8.254-1.523-15.626-1.507-20.51.699-2.961 1.337-3.388 3.312-2.49 4.97-.704 1.267-.283 2.786.78 4.03-.502.094-.993.198-1.462.33-5.705 1.6-3.726 6.202.104 7.863",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__h)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__i"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__i)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M105.195 152.275h97.188v49.69h-97.188Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__j"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M136.961 64.648a721.21 721.21 0 0 1-9.325 4.553c1.454.35 2.938.755 4.443 1.21 4.946 1.493 17.453 4.27 23.404 6.286a.25.25 0 0 0 .08.01c.577 0 2.662-1.285 5.75-2.57 3.09-1.285 7.183-2.57 11.78-2.57h.219a5.48 5.48 0 0 0 .127-.251s-.714-1.602-1.264-3.788a24.28 24.28 0 0 0-3.517-.251c-4.08 0-7.755.976-10.463 1.953-2.707.976-4.45 1.953-4.666 1.953h-.006c-3.04-.279-9.904-3.3-16.562-6.535",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__j)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__k"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__k)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M122.636 160.292h55.804v22.06h-55.804Z",
    fill: "#eda085"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__l"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M144.385 60.957c-.481.222-.965.455-1.45.7a976.472 976.472 0 0 1-5.974 2.99c6.658 3.236 13.523 6.257 16.562 6.535h.006c.217 0 1.959-.976 4.666-1.952 2.708-.977 6.382-1.953 10.463-1.953 1.145 0 2.32.076 3.517.251a23.575 23.575 0 0 1-.27-1.202c-.574-2.906-.62-4.377-1.074-5.295h-.173c-4.082 0-7.757.976-10.465 1.953-2.71.977-4.452 1.953-4.67 1.953h-.006c-2.207-.202-6.433-1.852-11.132-3.98",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__l)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__m"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__m)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M131.961 165.817h45.214v20.226H131.96Z",
    fill: "#e88a6c"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__n"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M121.362 46.116c-.783.443-1.009 1.074-.838 1.73.287-.595.567-1.174.838-1.73",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__n)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__o"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__o)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M115.47 189.154h10.892v11.73h-10.891Z",
    fill: "#39ae89"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__p"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M158.982 57.501c-4.424 0-9.376 1.05-14.597 3.456 4.699 2.128 8.925 3.778 11.132 3.98h.005c.22 0 1.962-.976 4.67-1.953 2.709-.977 6.384-1.953 10.466-1.953h.173a2.179 2.179 0 0 0-.761-.863c-.285-.16-.578-.31-.875-.458-.22-.092-.432-.192-.639-.297-2.747-1.22-5.987-1.912-9.574-1.912",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__p)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__q"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__q)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M139.385 172.063h36.446v17.436h-36.446Z",
    fill: "#e27658"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__r"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M183.353 87.445c4.15-.857 10.292-20.271 2.22-17.382-3.439 1.233-6.8 1.519-12.415 1.504-4.623-.012-8.741 1.28-11.845 2.57-3.254 1.355-5.393 2.709-5.83 2.56-5.951-2.016-18.458-4.793-23.404-6.286-8.657-2.615-16.615-3.586-22.251-2.05-5.973 1.628-3.926 6.223.071 7.868 2.98 1.226 36.994 14.262 46.181 14.116.796-.013 12.703.104 27.273-2.9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__r)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__s"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__s)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M101.083 146.654h93.438v32.717h-93.438Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__t"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M127.128 69.444c-.706.336-1.37.65-1.988.94l2.644 12.134 1.882.658-1.232-13.383c-.442-.121-.877-.238-1.306-.35",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__t)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__u"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__u)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M120.14 153.824h14.526v23.732H120.14Z",
    fill: "#f2bca3"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__v"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M118.846 41.5c-.725-3.323-4.039-5.453-7.362-4.729L27.876 54.578c-3.326.726-6.968 1.933-5.362 9.261l9.243 42.91c.724 3.323 3.565 5.479 6.891 4.756l84.695-18.245c6.474-1.412 5.538-5.716 4.812-9.04l-9.31-42.72",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__v)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__w"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__w)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.122 125.355H133.67v85.015H17.122Z",
    fill: "#121a22"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__x"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M118.388 42.209c-.725-3.322-4.04-5.453-7.362-4.727L27.418 55.287c-3.326.726-6.968 1.934-5.363 9.262l9.244 42.91c.724 3.322 3.565 5.478 6.89 4.757l84.695-18.245c6.475-1.414 5.54-5.717 4.813-9.041l-9.309-42.721",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__x)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__y"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__y)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.664 124.645h116.547v85.015H16.664Z",
    fill: "#121a22"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__z"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M56.719 108.182c-3.202-1.61-7.067-3.077-12.038-4.306-5.676-1.404-10.304-1.72-14.353-1.479l-3.962-18.39c5.816-.809 12.24-.957 22.82 1.658 17.396 4.302 21.282 11.509 30.383 17.595l-22.85 4.922",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__z)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__A"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__A)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.366 128.818h63.203v34.696H21.366Z",
    fill: "#1c2a40"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__B"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M112.424 96.183c-3.13-.297-6.698-.9-10.93-1.947C76.39 88.03 79.422 75.77 54.32 69.564c-14.469-3.577-22.153-.11-30.697 1.712l-1.584-7.354s-1.207-3.874.608-6.174c1.436-1.822 4.456-2.393 4.456-2.393l24.825-5.427c2.096.338 4.378.802 6.897 1.425 25.102 6.207 22.071 18.466 47.172 24.672 8.57 2.12 14.532 1.807 19.931.788l1.533 7.018s1.683 5.326-.148 7.72c-1.83 2.392-7.583 3.058-7.583 3.058l-7.307 1.574",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__B)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__C"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__C)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.646 140.817h116.522v56.255H16.646Z",
    fill: "#1c2a40"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__D"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M122.953 63.516c-3.136-.296-6.706-.897-10.952-1.946-17.715-4.38-21.42-11.774-30.888-17.929l22.748-4.9c3.317 1.732 7.355 3.31 12.645 4.617.757.188 1.491.35 2.213.5l4.234 19.658",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__D)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__E"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__E)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M76.113 173.484h51.84v34.775h-51.84Z",
    fill: "#1c2a40"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__F"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M106.024 84.041a7.499 7.499 0 1 1 14.66-3.158 7.499 7.499 0 0 1-14.66 3.158",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__F)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__G"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__G)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M100.854 147.038h25v25h-25Z",
    fill: "#fffffe"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__H"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m109.4 81.769.226 1.164.982-.19.099.509-.982.19.148.76 1.054-.205.1.512-1.658.322-.573-2.945.604-.117Zm2.234-.434.22 1.13.326-.064.47-1.264.681-.132c-.094.219-.294.702-.6 1.448a.95.95 0 0 1 .459.24c.12.117.196.262.23.435.058.297.006.536-.154.719-.16.182-.437.312-.83.388l-.843.164-.573-2.945.614-.12Zm.318 1.637.155.796.186-.036c.198-.039.338-.097.42-.174.084-.077.112-.186.084-.326-.027-.14-.093-.235-.198-.283-.106-.048-.255-.053-.449-.015l-.198.038Zm3.41-2.362.1.516-1.053.204.148.76.98-.19.099.511-.98.19.126.647 1.053-.205.099.512-1.666.324-.572-2.945 1.666-.324Zm2.27-.441.1.516-1.053.204.147.76.98-.19.1.51-.98.191.125.647 1.053-.205.1.512-1.666.324-.573-2.945 1.666-.324Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__H)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__I"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__I)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m105.415 151.307 18.65 3.625-2.48 12.761-18.65-3.625Z",
    fill: "#17e69a"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__J"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m56.957 108.173-14.125 3.043 14.125-3.043m-18.793 4.048c-.241.051-.479.087-.713.11l-.014.047.727-.157",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__J)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__K"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__K)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M32.437 124.622h29.52v14.205h-29.52Z",
    fill: "#64bda7"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__L"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M99.184 64.374a.927.927 0 0 0-.322.09c-.505.27-.93.668-1.23 1.156l-.122.045a.717.717 0 0 0-.472.902l-.07.104c-.66-.492-1.803.133-1.431.96l-45.522 9.677-3.671-17.271L96.51 49.373l3.148 14.809a.976.976 0 0 0-.474.192Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__L)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__M"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__M)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m46.164 158.762 59.948 12.742-5.75 27.053-59.948-12.742Z",
    fill: "#f13335"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__N"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M92.797 80.542 74.963 96.69l-7.64-3.49-3.507-1.605 7.417-9.72.618 3.12.599-.128 20.347-4.325Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__N)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__O"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__O)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m61.483 137.334 39.758 8.45-5.253 24.714-39.758-8.45Z",
    fill: "#676a6d"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__P"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m69.486 84.193 22.493-4.781-2.232-10.502-22.493 4.781 2.232 10.502Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__P)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__Q"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__Q)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m65.635 151.877 32.274 6.86-4.311 20.283-32.275-6.86Z",
    fill: "#f13335"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__R"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m45.98 61.457 51.486-10.944-.273-1.285-51.487 10.944.273 1.285Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__R)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__S"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__S)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m42.128 174.613 61.269 13.023-2.352 11.066-61.27-13.023Z",
    fill: "#e5e7e6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__T"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m90.863 74.16-1.116-5.25-20.36 4.28-.335-1.574 31.723-6.743-9.912 9.286Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__T)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__U"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__U)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m66.66 157.585 41.505 8.822-3.54 16.65-41.503-8.822Z",
    fill: "#676a6d"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__V"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m69.052 71.616 31.723-6.743-.206-.967-31.723 6.743.206.967Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__V)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__W"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__W)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m65.2 164.454 41.505 8.822-2.285 10.748-41.504-8.822Z",
    fill: "#e0d8d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__X"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m51.596 84.748 19.372-4.117-4.979-23.425-19.371 4.118 4.978 23.424Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__X)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__Y"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__Y)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m47.745 151.322 29.153 6.196-7.058 33.206-29.153-6.197Z",
    fill: "#f46364"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__Z"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m76.122 80.3 4.588-.976-1.515-7.123-4.587.975 1.514 7.123Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__Z)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aa"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aa)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m72.27 155.77 14.37 3.054-3.593 16.905-14.37-3.054Z",
    fill: "#656666"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ab"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m76.317 79.718 3.977-.846-.245-1.154-3.977.845.245 1.155Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ab)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ac"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ac)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m72.466 156.352 13.759 2.924-2.325 10.936-13.758-2.924Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ad"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m75.995 78.2 3.977-.845-1.021-4.805-3.977.846 1.02 4.805Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ad)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ae"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ae)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m72.144 157.869 13.758 2.924-3.1 14.587-13.759-2.924Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__af"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m53.071 81.447 4.588-.975-1.515-7.123-4.587.975 1.514 7.123Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__af)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ag"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ag)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m49.22 154.623 14.369 3.054-3.593 16.905-14.37-3.054Z",
    fill: "#656666"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ah"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m53.266 80.865 3.977-.845-.245-1.155-3.977.846.245 1.154Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ah)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ai"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ai)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m49.415 155.205 13.759 2.924-2.325 10.936-13.758-2.924Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aj"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m52.944 79.348 3.977-.845-1.021-4.805-3.977.845 1.02 4.805Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aj)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ak"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ak)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m49.093 156.722 13.758 2.924-3.1 14.587-13.759-2.925Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__al"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m58.109 80.376 4.587-.975-1.514-7.123-4.587.975 1.514 7.123Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__al)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__am"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__am)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m54.258 155.694 14.369 3.054-3.594 16.905-14.369-3.055Z",
    fill: "#656666"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__an"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m58.304 79.794 3.977-.845-.245-1.155-3.977.846.245 1.154Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__an)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ao"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ao)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m54.453 156.275 13.759 2.925-2.325 10.936-13.758-2.925Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ap"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m57.982 78.277 3.977-.845-1.022-4.805-3.977.845 1.022 4.805Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ap)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aq"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aq)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m54.13 157.793 13.76 2.924-3.101 14.587-13.759-2.925Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ar"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m63.21 79.292 4.588-.976-1.514-7.123-4.588.976 1.514 7.123Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ar)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__as"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__as)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m59.359 156.778 14.369 3.054-3.593 16.905-14.37-3.054Z",
    fill: "#656666"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__at"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m63.405 78.71 3.978-.845-.246-1.155-3.977.845.245 1.155Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__at)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__au"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__au)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m59.554 157.36 13.759 2.924-2.325 10.936-13.758-2.924Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__av"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m63.083 77.193 3.977-.846-1.021-4.805-3.977.846 1.021 4.805Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__av)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aw"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aw)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M59.232 158.877 72.99 161.8l-3.1 14.587-13.759-2.925Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ax"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m81.456 79.166 4.587-.975-1.514-7.123-4.587.975 1.514 7.123Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ax)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ay"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ay)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m77.605 156.904 14.369 3.054-3.593 16.905-14.37-3.055Z",
    fill: "#656666"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__az"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m81.651 78.584 3.977-.845-.245-1.155-3.977.846.245 1.154Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__az)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aA"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aA)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m77.8 157.486 13.759 2.924-2.325 10.936-13.758-2.924Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aB"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m81.329 77.067 3.977-.845-1.021-4.805-3.977.845 1.02 4.805Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aB)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aC"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aC)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m77.478 159.003 13.758 2.924-3.1 14.587-13.759-2.925Z",
    fill: "#d6d6d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aD"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m61.473 57.494.104.49-1.32.28.095.45-9.13 1.94-.095-.45-.707.15-.104-.489-1.14.242-.136-.643 13.433-2.856.137.644-1.137.242Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aD)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aE"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aE)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m45.525 175.023 23.215 4.934-2.416 11.365-23.215-4.934Z",
    fill: "#bcbcbc"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aF"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m48.374 72.723 20.012-4.254-.396-1.864-20.012 4.253.396 1.865Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aF)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aG"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aG)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m44.523 163.347 29.793 6.333-2.475 11.646-29.794-6.333Z",
    fill: "#e0d8d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aH"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m50.782 86.223 20.454-4.348-.266-1.248-20.453 4.347.265 1.249Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aH)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aI"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aI)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m46.931 149.847 30.235 6.427-2.344 11.03-30.235-6.427Z",
    fill: "#e0d8d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aJ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m68.137 85.784 24.66-5.242-.265-1.248-24.66 5.242.265 1.248Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aJ)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aK"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aK)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m64.286 150.286 34.442 7.32-2.345 11.03-34.441-7.32Z",
    fill: "#e0d8d6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aL"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m51.109 86.153 11.984 6.392 8.14-10.67-20.124 4.278Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aL)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aM"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aM)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m49.075 141.364 29.906 6.357-3.897 18.334-29.906-6.357Z",
    fill: "#717777"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aN"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m70.904 67.934 25.358-5.39-2.669-12.554-25.358 5.39 2.669 12.554Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aN)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aO"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aO)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m67.052 168.136 35.14 7.469-4.747 22.335-35.14-7.47Z",
    fill: "#d3d2d1"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aP"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m72 66.728 10.803-2.296-.959-4.512-10.804 2.296.96 4.512Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aP)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aQ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aQ)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m68.148 169.341 20.585 4.376-3.038 14.293-20.585-4.375Z",
    fill: "#bfbec8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aR"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m83.873 64.204 10.804-2.296-.96-4.512-10.803 2.296.959 4.512Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aR)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aS"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aS)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m80.022 171.865 20.585 4.376-3.038 14.293-20.585-4.375Z",
    fill: "#bfbec8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aT"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m82.613 58.275 10.804-2.296-.936-4.404-10.804 2.297.936 4.403Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aT)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aU"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aU)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m78.761 177.795 20.586 4.375-3.015 14.185-20.586-4.376Z",
    fill: "#bfbec8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aV"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m70.739 60.799 10.804-2.296-.936-4.404-10.804 2.297.936 4.403Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aV)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aW"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aW)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m66.888 175.27 20.585 4.376-3.015 14.185-20.585-4.376Z",
    fill: "#bfbec8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aX"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m54.732 68.516 5.857-1.245-1.75-8.235-5.857 1.245 1.75 8.235Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aX)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aY"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aY)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m50.88 167.554 15.639 3.324-3.83 18.016-15.638-3.324Z",
    fill: "#656666"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__aZ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M115.544 65.305c2.447 2.096 6.952 7.206 12.105 1.666 1.98-2.133 3.942-11.728 5.7-16.742 2.46-7.028 2.308-9.129-1.078-12.031-3.388-2.903-7.347-1.142-8.19 2.013-.748 2.79-11.926 22.19-8.537 25.094",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__aZ)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ba"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ba)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M109.906 167.533h30.12v42.744h-30.12Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bb"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M128.607 36.724a4.69 4.69 0 0 0-4.526 3.487c-.448 1.67-4.64 9.304-7.2 15.78 3.675-2.024 9.973-5.261 13.71-7.439 1.069-2.309 2.603-4.952 4.072-7.36-.42-1.063-1.208-1.98-2.392-2.994-1.204-1.032-2.481-1.474-3.664-1.474",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bb)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bc"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bc)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M111.881 181.009h27.782v29.267H111.88Z",
    fill: "#e88a6c"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M129.59 54.34c1.866 1.975 5.193 6.66 10.006 2.468 1.852-1.614 4.348-9.492 6.265-13.54 2.685-5.678 2.745-7.452.16-10.187-2.585-2.736-6.063-1.61-7.047.962-.878 2.275-11.97 17.56-9.385 20.297",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bd)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__be"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__be)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M124.2 178.502h28.718v37.001H124.2Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bf"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M142.66 31.497a3.954 3.954 0 0 0-3.686 2.546c-.592 1.534-5.827 8.98-8.382 14.51a42.394 42.394 0 0 0 1.791-1.094 361.635 361.635 0 0 0 9.563-6.508c.125-.086.244-.171.369-.26 2.24-1.577 3.9-3.275 5.4-5.046-.278-.866-.843-1.663-1.695-2.564-1.048-1.11-2.244-1.584-3.36-1.584",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bf)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bg"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bg)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M125.592 188.448h27.123v27.055h-27.123Z",
    fill: "#e88a6c"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bh"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m233.858 28.063-4.417 11.649c-9.039 4.716-19.792 11.124-22.003 13.45-6.019 6.335-17.316 33.205-24.085 34.283-2.36.374-25.236-10.41-13.811-13.113 1.962-.463 3.213-1.584 3.898-3.016 0 0-.989-2.216-1.535-4.99-.795-4.024-.575-5.297-1.835-6.158-.285-.16-.578-.31-.875-.458-.22-.092-.432-.192-.639-.297-6.447-2.864-15.596-2.814-25.621 2.244-11.019 5.563-20.91 10.302-22.6 10.84-4.743 1.517-9.675-1.244-10.358-7.14-.424-3.663 1.494-5.862 4.322-7.849 2.126-1.493 14.145-7.472 18.084-10.049a361.635 361.635 0 0 0 9.563-6.508c.125-.086.244-.171.369-.26 8.903-6.267 8.634-14.434 25.61-21.556.828-.469 1.613-.82 2.286-1.017 7.66-2.26 18.564-2.146 36.414-8.695l27.233 18.64",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bh)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bi"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bi)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M104.918 149.546h133.94v88.031h-133.94Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bj"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M197.185 12.494c-9.836 2.458-20.438 3.853-26.229 5.414 6.126-1.648 14.287-2.033 26.23-5.414",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bj)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bk"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bk)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M165.956 219.092h36.23v15.414h-36.23Z",
    fill: "#39ae89"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bl"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M110 65.246",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bl)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bm"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bm)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M105 170.886h10.358v10.868H105Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bn"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M201.6 11.294c-1.442.428-2.918.826-4.415 1.2-11.942 3.381-20.103 3.766-26.229 5.414-.258.07-.506.14-.745.21-.673.198-1.458.548-2.287 1.017-12.704 5.33-15.749 11.244-20.209 16.51-1.5 1.771-3.16 3.47-5.4 5.046-.125.089-.244.174-.369.26a361.635 361.635 0 0 1-9.563 6.508c-.486.317-1.094.687-1.791 1.093-4.96 2.89-14.43 7.647-16.294 8.956-2.562 1.8-4.377 3.776-4.38 6.857a8.611 8.611 0 0 0 .061 1.01v.007l.002.01.002.02v.002l.002.014c.03.238.066.471.108.7l.001.004.002.01.003.015.001.006c0 .005.002.01.003.014v.003c.608 3.147 2.495 5.283 4.868 6.207-3.587-1.916-6.697-9.625.556-13.474 11.222-5.956 25.848-14.39 29.959-16.663 5.628-3.112 10.565-13.9 23.37-19.238 4.162-1.735 14.137-.31 23.68-4 1.043-.403 2.044-.6 2.993-.6 2.391 0 4.449 1.25 5.986 3.593 2.162 3.3 12.543 22.96 13.81 25.638l.645-.397-14.37-35.952",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bn)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bo"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bo)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M104.918 164.613H220.97v71.093H104.918Z",
    fill: "#f2bca3"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bp"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m215.297 3.512 8.742 42.718-7.596 2.198-15.814-39.561 14.668-5.355",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bp)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bq"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bq)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M195.63 188.572h33.409v54.916h-33.41Z",
    fill: "#fffffe"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__br"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m228.01-7.698 13.387.076.023 51.506-22.3 4.49L204.866 3.94 228.01-7.698",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__br)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bs"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bs)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M199.866 188.625h46.554v66.073h-46.554Z",
    fill: "#1c2a40"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M228.01-7.698 204.867 3.939l2.222 6.704a31.574 31.574 0 0 1 1.977-.951 3.275 3.275 0 0 1 1.548-4.107l.006-.004.006-.002.004-.003.006-.003.003-.001a2.072 2.072 0 0 1 .046-.023l.008-.004h.002l.008-.004.003-.002.007-.003.01-.005a3.274 3.274 0 0 1 4.356 1.571l.005.011a.05.05 0 0 1 .002.004l.003.007.001.004.004.007.001.003.005.01.022.052C223.42 3.97 235.33-.15 241.4-1.687c0 0-.278-5.726-.032-5.935l-13.356-.076",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bt)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bu"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bu)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M199.866 226.357H246.4v28.341h-46.533Z",
    fill: "#0e1113"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bv"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M118.256 63.864c1.503 2.616 3.269 5.262 1.332 6.375-1.938 1.113-4.726-.105-6.231-2.72-1.5-2.614-1.147-5.637.79-6.751 1.936-1.111 2.607.483 4.11 3.096",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bv)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bw"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bw)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M107.428 166.349h18.012v20.242h-18.012Z",
    fill: "#fffffe"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bx"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M210.722 5.531a3.273 3.273 0 0 1 4.356 1.572 3.274 3.274 0 1 1-4.356-1.571",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bx)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__by"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__by)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M203.838 225.23h16.551v16.55h-16.55Z",
    fill: "#f7c061"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bz"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M210.683 5.55",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bz)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bA"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bA)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M205.638 231.428h10.045v10.022h-10.045Z",
    fill: "#0d0f0d"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bB"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M212.113 5.22a3.261 3.261 0 0 0-1.408.319c-.001 0-.002 0-.003.002-.003 0-.005.002-.008.003l-.002.001-.008.004h-.001a2.072 2.072 0 0 0-.054.027l-.004.003-.006.002-.006.004-.003.001a3.257 3.257 0 0 0-1.688 2.216c.752-.745 1.789-1.201 2.802-1.201 1.134 0 2.238.57 2.884 1.945a3.83 3.83 0 0 1 .375 1.502c.47-.869.552-1.933.116-2.9l-.005-.01-.001-.003-.004-.007a.06.06 0 0 1-.001-.004l-.003-.007a.05.05 0 0 0-.002-.004l-.005-.01a3.274 3.274 0 0 0-2.965-1.884",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bB)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bC"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bC)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M203.922 226.952h16.463v14.829h-16.463Z",
    fill: "#ec9037"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bD"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M55.125 189.22c-3.784-.878 1.323-17.717 8.642-14.785 7.39 2.96 26.035 7.29 27.402 6.799 5.497-1.98 17.023-4.68 21.589-6.143 7.993-2.561 15.307-3.484 20.432-1.918 5.43 1.66 3.442 6.238-.259 7.857-2.758 1.207-34.238 14.03-42.648 13.833-.729-.017-21.89-2.56-35.158-5.642",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bD)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bE"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bE)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M48.844 42.135h92.692v32.46H48.844Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bF"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M133.877 183.966c-2.558 1.59-31.877 18.785-40.23 19.791-.661.08-18.519.516-31.95-.292l.103-.019-1.938-11.05-2.397.42c1.314-3.473 3.694-6.288 7.017-5.484 7.737 1.874 26.807 3.494 28.089 2.81 5.16-2.746 16.179-7.067 20.491-9.169 7.545-3.677 14.652-5.639 19.948-4.822 5.61.867 4.3 5.682.867 7.815",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bF)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bG"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bG)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M52.465 33.054h89.372v37.978H52.465Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bH"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M138.422 189.836c-2.674 1.593-33.329 18.819-42.057 19.834-.634.077-16.378.463-29.81-.084l-1.037-5.929c-1.301-.054-2.58-.119-3.822-.192l.104-.019-.992-5.651-1.978.348c.435-.974.96-1.876 1.577-2.638l-.545-3.11-2.397.421c.38-1.007.853-1.956 1.41-2.778-1.3-.267-2.557-.54-3.75-.817-3.784-.879 1.323-17.718 8.642-14.786 7.39 2.96 26.035 7.29 27.402 6.799 5.497-1.98 17.023-4.68 21.589-6.143 7.993-2.561 15.307-3.484 20.432-1.918 3.107.95 3.783 2.854 3.102 4.613.86 1.167.637 2.727-.26 4.096.51.03 1.01.07 1.492.142 5.862.86 4.486 5.676.898 7.812",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bH)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bI"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bI)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M48.844 27.126h97.675v47.47H48.844Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bJ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M114.78 187.066c-6.192 4.056-12.617 7.926-15.596 8.59a.086.086 0 0 1-.018 0c-.232 0-1.623-.54-3.765-1.082-2.141-.54-5.034-1.082-8.267-1.082-2.19 0-4.538.248-6.915.914-.267 2.237-.772 3.917-.772 3.917.05.08.104.157.159.233l.152-.02a25.817 25.817 0 0 1 3.358-.215c3.744 0 7.119.77 9.706 1.54 2.588.769 4.387 1.538 4.977 1.538.06 0 .109-.008.143-.025 5.647-2.757 17.698-7.103 22.414-9.214a81.49 81.49 0 0 1 4.252-1.766 718.546 718.546 0 0 1-9.829-3.328",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bJ)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bK"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bK)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M74.447 35.6h55.161v24.334H74.447Z",
    fill: "#eda085"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bL"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M106.947 184.35c-4.39 2.709-8.372 4.883-10.535 5.365a.086.086 0 0 1-.02.001c-.233 0-1.625-.54-3.767-1.082s-5.035-1.083-8.268-1.083c-1.172 0-2.39.071-3.632.24-.334.967-.191 2.432-.39 5.387-.029.423-.069.834-.116 1.228 2.377-.666 4.724-.914 6.915-.914 3.233 0 6.126.541 8.267 1.083 2.142.54 3.533 1.082 3.765 1.082.007 0 .013 0 .018-.002 2.98-.663 9.404-4.533 15.596-8.59-2.029-.701-4.146-1.442-6.306-2.206a44.86 44.86 0 0 0-1.528-.509",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bL)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bM"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bM)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M75.22 41.343h44.56V62.65H75.22Z",
    fill: "#e88a6c"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bN"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M95.805 182.544c-5.147 0-9.586 1.26-13.03 3.352-.192.13-.39.256-.595.375-.277.184-.548.372-.81.566a2.178 2.178 0 0 0-.645.953c1.243-.168 2.46-.239 3.632-.239 3.233 0 6.126.541 8.268 1.083 2.142.541 3.534 1.082 3.768 1.082l.019-.001c2.163-.482 6.145-2.656 10.534-5.365-3.97-1.246-7.713-1.806-11.141-1.806",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bN)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bO"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bO)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M75.725 47.284h36.222v17.172H75.725Z",
    fill: "#e27658"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bP"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M71.668 215.582c-4.226-.32-12.789-18.795-4.416-16.956 3.569.784 6.939.64 12.506-.09 5.066-.663 9.723.33 13.064 1.324 2.853.849 4.748 1.697 5.12 1.514 5.647-2.757 17.698-7.103 22.414-9.214 8.253-3.695 16.024-5.671 21.81-4.865 6.13.854 4.685 5.672.93 7.812-2.799 1.596-34.877 18.857-44.008 19.88-.792.09-12.587 1.72-27.42.595",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bP)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bQ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bQ)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M58.714 21.023h92.627v38.86H58.714Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bR"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M133.014 200.464c-.771.397-1.57.807-2.391 1.225l.02.118c.85-.426 1.65-.831 2.4-1.216l-.029-.127",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bR)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bS"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bS)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M125.623 35.193h12.42v11.343h-12.42Z",
    fill: "#39ae89"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bT"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m128.989 191.805 1.634 9.884c.822-.418 1.62-.828 2.391-1.225l-1.822-8a86.357 86.357 0 0 1-2.203-.659",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bT)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bU"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bU)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M123.989 35.31h14.025v19.885H123.99Z",
    fill: "#f2bca3"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bV"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M136.106 184.991c-2.16 2.39-5.978 8.032-11.794 3.194-2.237-1.864-5.403-11.132-7.784-15.88-3.336-6.659-3.453-8.761-.463-12.071 2.99-3.31 7.141-2.067 8.38.954 1.097 2.671 14.653 20.492 11.661 23.803",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bV)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bW"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bW)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M108.92 46.914h32.616v41.82H108.92Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bX"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M120.11 158.267c-1.354 0-2.8.589-4.045 1.967-1.045 1.157-1.71 2.166-1.992 3.274 1.764 2.2 3.622 4.628 4.975 6.782 2.103.888 4.95 1.98 7.744 3.038-.35-1.543-.811-3.268-1.043-4.35l.107.07-2.039-8.95a4.685 4.685 0 0 0-3.707-1.831",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bX)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bY"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bY)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M109.073 63.672h22.72v25.061h-22.72Z",
    fill: "#e88a6c"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__bZ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M184.659 110.017a.211.211 0 0 0-.102.026c-.02.014-.016.021.008.021a.332.332 0 0 0 .06-.007c.071-.014.098-.03.06-.038a.131.131 0 0 0-.026-.002m-10.054 1.922a.21.21 0 0 0-.102.026c-.021.013-.016.02.008.02a.32.32 0 0 0 .06-.007c.07-.014.097-.03.059-.037a.164.164 0 0 0-.025-.002m-10.055 1.92a.214.214 0 0 0-.103.027c-.02.014-.015.02.01.02a.35.35 0 0 0 .059-.007c.07-.013.097-.03.06-.037a.136.136 0 0 0-.026-.002",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__bZ)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ca"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ca)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M159.435 123.093h30.267v13.89h-30.267Z",
    fill: "#47b6a1"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cb"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m181.808 112.758-.118.084.261-.06-.143-.024m-10.255 2.336-.118.084.261-.06-.143-.024m-10.255 2.337-.119.084.262-.06-.143-.024m47.788 90.884-5.695-1.75-.186.042-4.375 4.045-5.695-1.75-.186.042-4.374 4.044-5.694-1.75-.187.043-4.373 4.044-5.694-1.75-.186.042-4.373 4.044-5.695-1.75-.186.042-4.373 4.044-5.694-1.75-.186.042-4.374 4.045-5.694-1.75-.187.042-3 2.751-.448-1.966-.108-.471-21.577-94.704 2.983-2.78 5.8 1.783 4.456-4.12 5.8 1.783 4.455-4.119 5.8 1.783 4.455-4.12 5.799 1.784 4.453-4.12 5.8 1.783 4.455-4.118 5.799 1.782 4.454-4.12 5.8 1.784 3.082-2.827.555 2.438-.005.005.006-.001 21.577 94.7-2.983 2.78",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cb)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cc"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cc)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M111.546 13.623H217.07v124.983H111.546Z",
    fill: "#e2d1b1"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m208.76 208.833-5.695-1.75-.186.042-4.375 4.045-5.694-1.75-.186.042-4.375 4.044-5.694-1.75-.186.042-4.374 4.044-5.694-1.75-.186.042-4.373 4.045-5.694-1.75-.186.041-4.374 4.045-5.694-1.75-.186.042-4.374 4.044-5.694-1.75-.187.042-3 2.752-22.133-97.141 2.983-2.78 5.8 1.783 4.457-4.12 5.8 1.783 4.455-4.119 5.8 1.782 4.454-4.119 5.8 1.783 4.453-4.119 5.8 1.783 4.454-4.119 5.8 1.783 4.454-4.12 5.8 1.784 3.081-2.827.555 2.438-.005.005.006-.002 21.577 94.7-2.983 2.78",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cd)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ce"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ce)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M111.22 13.105h105.524v124.983H111.22Z",
    fill: "#f0f1f6"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cf"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m208.76 208.833-5.695-1.75-.186.042-4.375 4.045-5.694-1.75-.186.042-4.375 4.044-5.694-1.75-.186.042-4.374 4.044-5.694-1.75-.186.042-4.373 4.045-5.694-1.75-.186.041-4.374 4.045-5.694-1.75-.186.042-4.374 4.044-5.694-1.75-.187.042-3 2.752-22.133-97.141 2.983-2.78 5.8 1.783 4.457-4.12 5.8 1.783 4.455-4.119 5.8 1.782 4.454-4.119 5.8 1.783 4.453-4.119 5.8 1.783 4.454-4.119 5.8 1.783 4.454-4.12 5.8 1.784 3.081-2.827.555 2.438-.005.005.006-.002 21.577 94.7-2.983 2.78",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cf)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cg"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cg)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M111.22 13.105h105.524v124.983H111.22Z",
    fill: "#fbcb2f",
    fillOpacity: 0.3
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ch"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m186.388 130.285 2.002-.456a.325.325 0 0 0-.144-.633l-2.002.457a.324.324 0 0 0 .144.632Zm-60.438 6.169 9.696-2.21a.702.702 0 1 0-.312-1.37l-9.696 2.21a.702.702 0 1 0 .312 1.37Zm.74 3.243 15.808-3.602a.703.703 0 0 0-.312-1.37l-15.809 3.602a.703.703 0 0 0 .312 1.37Zm3.54 11.524 28.438-6.436a1.383 1.383 0 0 0 1.049-1.654 1.387 1.387 0 0 0-1.655-1.05l-28.436 6.435a1.387 1.387 0 0 0 .604 2.705Zm55.066 2.03 6.664-1.49a1.39 1.39 0 0 0 1.05-1.656 1.389 1.389 0 0 0-1.655-1.05l-6.665 1.492a1.384 1.384 0 0 0-1.05 1.653 1.387 1.387 0 0 0 1.656 1.05Zm-51.916 11.684 34.274-7.743a1.386 1.386 0 0 0-.604-2.703l-34.275 7.742a1.385 1.385 0 1 0 .605 2.704Zm53.207-5.905 6.665-1.492a1.387 1.387 0 0 0 1.05-1.654 1.387 1.387 0 0 0-1.654-1.05l-6.666 1.49a1.385 1.385 0 1 0 .605 2.706Zm1.479 6.376 6.663-1.492a1.384 1.384 0 1 0-.604-2.702l-6.665 1.49a1.385 1.385 0 1 0 .606 2.704Zm-53.395 5.308 28.438-6.436a1.387 1.387 0 0 0-.606-2.704l-28.436 6.435a1.385 1.385 0 0 0 .604 2.705Zm1.478 6.375 34.275-7.74a1.386 1.386 0 0 0-.605-2.703l-34.274 7.74a1.385 1.385 0 1 0 .604 2.703Zm53.208-5.905 6.665-1.49a1.386 1.386 0 1 0-.605-2.704l-6.666 1.49a1.386 1.386 0 0 0 .606 2.704Zm-51.916 11.685 28.437-6.435a1.384 1.384 0 1 0-.605-2.704l-28.436 6.435a1.387 1.387 0 0 0 .604 2.704Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ch)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ci"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ci)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M120.091 54.097h82.015v63.715h-82.015Z",
    fill: "#87868f"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cj"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m139.435 188.58-2.003.457a.325.325 0 1 0 .144.632l2.002-.457a.324.324 0 1 0-.143-.632",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cj)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ck"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ck)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M132.18 47.323h12.651v11.105H132.18Z",
    fill: "#4c545e"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cl"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m198.7 175.077-2.003.456a.324.324 0 0 0 .145.633l2.002-.457a.324.324 0 1 0-.144-.632",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cl)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cm"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cm)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M191.445 60.826h12.651v11.105h-12.65Z",
    fill: "#4c545e"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cn"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m136.616 140.96-3.817.87a.324.324 0 1 0 .143.632l3.818-.87a.324.324 0 0 0-.144-.632Zm7.635-1.74-3.817.87a.325.325 0 0 0 .144.633l3.817-.87a.324.324 0 0 0-.144-.633Zm7.635-1.74-3.817.87a.324.324 0 1 0 .144.633l3.817-.87a.325.325 0 0 0-.144-.632Zm7.635-1.739-3.817.87a.324.324 0 0 0 .144.633l3.817-.87a.324.324 0 0 0-.144-.633Zm7.635-1.74-3.817.87a.324.324 0 1 0 .144.633l3.817-.87a.324.324 0 1 0-.144-.632Zm7.635-1.739-3.817.87a.324.324 0 0 0 .144.632l3.817-.87a.324.324 0 1 0-.144-.632Zm3.962-.237 3.818-.87a.324.324 0 0 0-.145-.633l-3.817.87a.324.324 0 0 0 .144.633Zm-51.63 11.763 2.002-.456a.324.324 0 0 0-.144-.632l-2.002.456a.324.324 0 1 0 .144.632Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cn)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__co"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__co)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M121.726 93.203h66.097v23.283h-66.097Z",
    fill: "#4c545e"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cp"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M120.78 175.903c-1.6 2.197-4.304 7.268-9.612 3.722-2.042-1.365-5.521-8.86-7.937-12.633-3.387-5.289-3.672-7.041-1.455-10.083 2.215-3.042 5.808-2.369 7.111.058 1.161 2.144 14.108 15.893 11.892 18.936",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cp)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cq"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cq)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M95.351 56.151h30.683v35.971H95.351Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cr"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M105.406 154.878c-1.261 0-2.596.61-3.63 2.03-.73 1.003-1.19 1.865-1.355 2.76 1.713 1.566 3.576 3.038 6 4.318a361.326 361.326 0 0 0 10.712 5.448c.521.253 1.172.542 1.915.856-1.353-2.154-3.212-4.581-4.975-6.782-2.458-3.07-4.73-5.7-5.186-6.541a3.96 3.96 0 0 0-3.48-2.09",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cr)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cs"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cs)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M95.421 66.71h28.627v25.412H95.421Z",
    fill: "#e88a6c"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__ct"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M125.749 168.978c.232 1.082.693 2.807 1.043 4.35l.043.016-.979-4.297-.107-.07",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__ct)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cu"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cu)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M120.749 63.656h11.086v14.366H120.75Z",
    fill: "#a95436"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cv"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m125.856 169.047.98 4.297c2.969 1.125 5.874 2.212 7.755 2.979a1.384 1.384 0 0 1 .393-1.67c-1.565-1.059-5.627-3.345-9.128-5.606m11.733 7.716-1.315.298.075.038c1.332.702 2.498 1.465 3.393 2.409l.229-.052c-.512-.942-1.295-1.75-2.382-2.693",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cv)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cw"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cw)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M120.856 57.493h24.115v20.46h-24.115Z",
    fill: "#b68f62"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cx"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m139.971 179.456-.229.052c.197.207.38.423.55.648a5.615 5.615 0 0 0-.321-.7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cx)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cy"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cy)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M134.742 56.844h10.55v10.7h-10.55Z",
    fill: "#a37b4f"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cz"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M134.984 174.654a1.384 1.384 0 0 0-.393 1.669c.738.3 1.318.552 1.683.738l1.315-.298c-.615-.533-1.328-1.109-2.145-1.776a6.728 6.728 0 0 0-.46-.333",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cz)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cA"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cA)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M129.462 59.94h13.127v12.406h-13.127Z",
    fill: "#a37b4f"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cB"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m14.014 163.114 5.864 10.991c9.565 3.527 21.047 8.515 23.537 10.54 6.776 5.517 21.401 30.73 28.253 30.938 2.387.07 23.704-13.538 12.03-14.765-2.006-.209-3.39-1.162-4.251-2.495 0 0 .698-2.323.887-5.145.276-4.092-.104-5.326 1.036-6.341.262-.194.533-.382.81-.566.205-.12.403-.245.595-.375 6.03-3.661 15.112-4.777 25.699-1.036 11.637 4.114 22.052 7.556 23.795 7.874 4.898.902 9.438-2.465 9.367-8.4-.047-3.687-2.23-5.624-5.287-7.235-2.3-1.21-14.981-5.61-19.216-7.665a361.326 361.326 0 0 1-10.314-5.238l-.399-.21c-9.629-5.083-10.4-13.217-28.145-18.121-.882-.36-1.705-.608-2.398-.718-7.886-1.267-18.686.234-37.225-3.989l-24.638 21.956",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cB)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cC"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cC)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.014 21.417h137.623v84.425H9.014Z",
    fill: "#fadac8"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cD"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M48.41 143.003c12.273 1.832 20.415 1.176 26.7 2.03-5.941-.81-16.633-.845-26.7-2.03",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cD)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cE"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cE)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M43.41 91.967h36.7v12.03h-36.7Z",
    fill: "#39ae89"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cF"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M141.684 184.187",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cF)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cG"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cG)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M136.63 51.926h10.055v10.887H136.63Z",
    fill: "#f7d1b7"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cH"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m43.875 142.375-9.677 37.488.69.313c.917-2.819 8.71-23.64 10.435-27.188 1.38-2.839 3.592-4.384 6.399-4.384.675 0 1.385.09 2.126.272 3.374.83 6.724 1.07 9.845 1.07 2.114 0 4.124-.11 5.967-.22s3.52-.219 4.967-.219c1.26 0 2.346.083 3.217.322 13.381 3.665 19.65 13.736 25.63 16.106 4.366 1.731 19.946 8.235 31.835 12.714 7.684 2.894 5.581 10.937 2.267 13.293 2.237-1.218 3.837-3.577 4.038-6.776l.001-.019v-.003l.001-.018v-.003l.002-.015a.09.09 0 0 1 0-.01v-.007c.014-.236.02-.477.018-.722v-.035c-.023-1.728-.513-3.072-1.344-4.178a7.349 7.349 0 0 0-.55-.649c-.895-.943-2.06-1.706-3.393-2.408l-.075-.038a24.927 24.927 0 0 0-1.683-.738c-1.88-.767-4.786-1.854-7.756-2.979a1.814 1.814 0 0 0-.043-.016c-2.794-1.059-5.641-2.15-7.744-3.038a42.157 42.157 0 0 1-1.916-.856 361.326 361.326 0 0 1-10.313-5.238l-.399-.21c-2.423-1.28-4.286-2.752-6-4.318-5.093-4.655-8.867-10.134-22.145-13.803-.882-.36-1.705-.608-2.398-.718-.246-.04-.502-.077-.767-.114-6.285-.854-14.427-.198-26.7-2.03-1.534-.18-3.05-.388-4.535-.628",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cH)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cI"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cI)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.198 45.058h117.438v59.567H29.198Z",
    fill: "#f2bca3"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cJ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m29.299 136.399-3.233 43.484 7.814 1.213 10.649-41.252-15.23-3.445",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cJ)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cK"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cK)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.066 55.904H49.53V110.6H21.066Z",
    fill: "#fffffe"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cL"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M.024 122.717v55.653l31.194 3.014 8.48-45.89L.025 122.717",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cL)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cM"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cM)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M-4.976 55.616h49.675v68.667H-4.976Z",
    fill: "#1c2a40"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cN"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M.024 122.717v9.37c.024-.024.092-.036.199-.036 2.036 0 18.51 4.228 29.836 7.647a3.275 3.275 0 0 1 4.035-1.878c.004 0 .007.002.01.003l.006.002.005.002.006.001.005.002.006.002a.134.134 0 0 1 .021.007l.011.004.012.004.011.004h.001a3.276 3.276 0 0 1 2.092 3.83c.775.266 1.469.516 2.069.747l1.35-6.934L.024 122.717",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cN)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cO"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cO)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M-4.976 94.572h49.675v29.71H-4.976Z",
    fill: "#0e1113"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cP"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M133.233 183.907c-1.158 2.786-2.572 5.636-.51 6.493 2.064.857 4.674-.707 5.835-3.49 1.154-2.785.42-5.739-1.643-6.597-2.062-.856-2.525.81-3.682 3.594",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cP)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cQ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cQ)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M126.673 46.365h17.431v20.547h-17.431Z",
    fill: "#fffffe"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cR"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M34.094 137.82a3.273 3.273 0 0 0-4.12 2.113 3.274 3.274 0 1 0 4.12-2.113",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cR)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cS"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M1 0h242v242H1Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cS)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.815 92.789h16.551v16.55H24.815Z",
    fill: "#f7c061"
  }))))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cT"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M147.93 189.313c5.402-1.148 10.712 2.3 11.86 7.702 1.149 5.402-2.3 10.713-7.702 11.86-5.402 1.149-10.712-2.3-11.86-7.702-1.149-5.402 2.3-10.712 7.702-11.86Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cT)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    strokeWidth: 2,
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#bfbec8",
    d: "M147.93 52.687c5.402 1.149 10.712-2.3 11.86-7.702 1.149-5.402-2.3-10.712-7.702-11.86-5.402-1.149-10.712 2.3-11.86 7.702-1.149 5.402 2.3 10.712 7.702 11.86Z"
  })), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cU"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M147.93 189.313c5.402-1.148 10.712 2.3 11.86 7.702 1.149 5.402-2.3 10.713-7.702 11.86-5.402 1.149-10.712-2.3-11.86-7.702-1.149-5.402 2.3-10.712 7.702-11.86Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cU)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cV"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M139 188h22v23h-22Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cV)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cW"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M139 188h22v23h-22Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cW)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M147.93 52.687c5.402 1.148 10.712-2.3 11.86-7.702 1.149-5.402-2.3-10.712-7.702-11.86-5.402-1.149-10.712 2.3-11.86 7.702-1.149 5.402 2.3 10.712 7.702 11.86Z",
    fill: "#fff"
  })), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cX"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M147.93 189.313c5.402-1.148 10.712 2.3 11.86 7.702 1.149 5.402-2.3 10.713-7.702 11.86-5.402 1.149-10.712-2.3-11.86-7.702-1.149-5.402 2.3-10.712 7.702-11.86Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cX)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cY"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M139 188h22v23h-22Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cY)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    strokeWidth: 2,
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#bfbec8",
    d: "M147.93 52.687c5.402 1.149 10.712-2.3 11.86-7.702 1.149-5.402-2.3-10.712-7.702-11.86-5.402-1.149-10.712 2.3-11.86 7.702-1.149 5.402 2.3 10.712 7.702 11.86Z"
  }))), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__cZ"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M147.93 189.313c5.402-1.148 10.712 2.3 11.86 7.702 1.149 5.402-2.3 10.713-7.702 11.86-5.402 1.149-10.712-2.3-11.86-7.702-1.149-5.402 2.3-10.712 7.702-11.86Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__cZ)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__da"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M139 188h22v23h-22Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__da)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__db"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M132 181h36v36h-36Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__db)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__dc"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M139 188h22v23h-22Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__dc)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m138.456 25.115 29.344 6.237-6.237 29.345-29.345-6.238Z",
    fill: "#87868f"
  })), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__dd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "m154.993 191.884-2.722 2.175a.86.86 0 0 0-.306.855l.23 1.08a7.488 7.488 0 0 1 1.63 1.909c.494.111.881.495.988.999l.272 1.278c.065.308.014.63-.14.907l.36 1.7c.056.172.349 1.204-.223 2.228-.496.888-1.478 1.494-2.92 1.8-1.442.307-2.586.153-3.4-.456-.94-.703-1.092-1.765-1.111-1.944l-.362-1.7a1.305 1.305 0 0 1-.497-.772l-.272-1.279a1.3 1.3 0 0 1 .266-1.095 6.865 6.865 0 0 1 .626-2.55l-.225-1.059a.864.864 0 0 0-.597-.648l-3.176-.95a2.948 2.948 0 0 1-2.038-2.214l-.22-1.035c-.322-1.517 4.31-3.321 6.847-3.86 2.538-.54 7.503-.775 7.826.742l.206.972a2.933 2.933 0 0 1-1.042 2.917Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__dd)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "empty-finance_with_avatar_svg__de"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 242)",
    d: "M139 188h22v23h-22Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#empty-finance_with_avatar_svg__de)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m140.974 27.695 24.454 5.198-6.237 29.344-24.454-5.198Z",
    fill: "#fff"
  })))))))));
});
var EmptyFinanceWithAvatar = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.EmptyFinanceWithAvatar = EmptyFinanceWithAvatar;